var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baidu-map',{staticClass:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"dragging":true,"double-click-zoom":true,"scroll-wheel-zoom":true},on:{"ready":_vm.handler,"click":_vm.onClick}},[_c('bm-scale')],1)}
var staticRenderFns = []

export { render, staticRenderFns }